import { Language } from "../types/language";

export const useAvailableLanguages = (): Language[] => {
  return ["en", "pl"];
};
